import React, { useState, useEffect } from 'react';
import { Search, ExternalLink, Calendar } from 'lucide-react';
import './Blogs.css';
 
const Blogs = () => {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');

    const user = 'avaantivirus2021';
    const rssFeedUrl = `https://medium.com/feed/@${user}`;

    useEffect(() => {
        fetchPosts();
    }, []);

    const fetchPosts = async () => {
        try {
            const response = await fetch(
                `https://api.rss2json.com/v1/api.json?rss_url=${encodeURIComponent(rssFeedUrl)}`
            );
            const data = await response.json();
            if (data.status === 'ok') {
                const processedPosts = data.items.map(post => ({
                    ...post,
                    description: cleanDescription(post.description),
                    thumbnail: extractThumbnail(post.description)
                }));
                setPosts(processedPosts);
            }
        } catch (err) {
            console.error('Error fetching posts:', err);
        } finally {
            setLoading(false);
        }
    };

    const cleanDescription = (html) => {
        // Create a temporary div to parse HTML
        const temp = document.createElement('div');
        temp.innerHTML = html;
        
        // Remove all images
        temp.querySelectorAll('img').forEach(img => img.remove());
        
        // Get text content only
        let text = temp.textContent || temp.innerText;
        
        // Clean up extra whitespace
        text = text.replace(/\s+/g, ' ').trim();
        
        // Return first 200 characters for preview
        return text.substring(0, 200) + '...';
    };

    const extractThumbnail = (html) => {
        const temp = document.createElement('div');
        temp.innerHTML = html;
        const img = temp.querySelector('img');
        return img ? img.src : null;
    };

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    };

    const filteredPosts = posts.filter(post =>
        post.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        post.description.toLowerCase().includes(searchTerm.toLowerCase())
    );

    if (loading) {
        return (
            <div className="blogs-loading">
                <div className="loading-spinner"></div>
            </div>
        );
    }

    return (
        <div className="blogs-container">
            <div className="blogs-header">
                <h2 className="highlight">My Blog Posts</h2>
                <div className="search-container">
                    <Search className="search-icon" size={20} />
                    <input
                        type="text"
                        placeholder="Search blogs..."
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="search-input"
                    />
                </div>
            </div>

            <div className="blogs-grid">
                {filteredPosts.map((post, index) => (
                    <article key={index} className="blog-card">
                        {post.thumbnail && (
                            <div className="blog-image">
                                <img src={post.thumbnail} alt={post.title} />
                            </div>
                        )}
                        <div className="blog-content">
                            <div className="blog-meta">
                                <Calendar size={16} />
                                <span>{formatDate(post.pubDate)}</span>
                            </div>
                            <h3>{post.title}</h3>
                            <p>{post.description}</p>
                            <a 
                                href={post.link} 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="read-more"
                            >
                                Read More
                                <ExternalLink size={16} />
                            </a>
                        </div>
                    </article>
                ))}
            </div>

            {filteredPosts.length === 0 && (
                <div className="no-results">
                    <p>No blog posts found matching your search.</p>
                </div>
            )}
        </div>
    );
};

export default Blogs;
